import React, { useRef } from 'react';
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { BASE_URL_API } from '../environment.js';
import '../css/Login.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import logo from '../img/WebLogo.svg';
import {Altcha} from '../components/Altcha.js'; 
export const Login = () => {
  const nav = useNavigate();
  const [Email, setEmail] = useState();
  const [Pass, setPass] = useState(); // State for traditional password input
  const altchaRef = useRef(null); // Create a ref for the Altcha component

  const HandleSubmit = async (e) => {
    e.preventDefault();
    const altchaPass = altchaRef.current ? altchaRef.current.value : null; // Get the value from Altcha
    const passwordToUse = Pass || altchaPass; // Use the traditional password if provided, otherwise use Altcha

    try {
      await axios.post(BASE_URL_API + 'users/login', {
        email: Email,
        password: passwordToUse,
      }).then(res => {
        if(res.data._id=='650bdeb49d0d4331b0da71b3'){
        localStorage.setItem('token', res.data._id);
        }
        console.log("storing the tokrn in the localstorage")
        const token=localStorage.getItem('token');
        console.log("the token is",token);
        if (res.data.usertype === "admin" && token=='650bdeb49d0d4331b0da71b3') {
          nav('/dashboard');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong! This Admin does not exist.',
          });
        }
      });
    } catch (err) {
      if (err) {
        console.log(err);
      }
    }
  };

  return (
    <div id="logbody" className='d-flex justify-content-center align-items-center bg-light ' 
      style={{
        height: '100vh',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>
      <div className="container-fluid  ">
        <div className="login-container col-lg-3 col-sm-6 col-md-5 " id="logcontainer" style={{opacity:'0.9'}}>
          <div className='d-flex justify-content-center mb-4'><img src={logo} alt="" style={{width:'150px'}} /></div>
          <form>
            <div className="form-group">
              <label htmlFor="username " className='font-weight-bold' style={{color:"#73be44"}}>Username</label>
              <input type="text" className="form-control" id="username" onChange={(e) => setEmail(e.target.value)} autoComplete='off' placeholder="Enter your username" />
            </div>
            <div className="form-group">
              <label htmlFor="password" className='font-weight-bold' style={{color:"#73be44"}}>Password </label>
              <input type="password" className="form-control" id="password" onChange={(e) => setPass(e.target.value)} placeholder="Enter your password" />
            </div>
            <div className="form-group">
              
              <Altcha ref={altchaRef} onStateChange={(ev) => console.log('Altcha state changed:', ev)} />
            </div>
          
          
            <button type="submit" className="btn btn-primary btn-block mb-2 mt-0" onClick={HandleSubmit}>Login</button>
                    <Link 
              to="/forgotpassword"
              style={{
                  textDecoration: 'none',
                  fontSize: '0.8em', // Adjust this to make the text smaller
                  float: 'right', // Align to the right
              }}
              // onClick={() => forgotPassword()} // Use a function reference here
              className="text-success"
          >
              Forgot Password?
          </Link>


            <label>
          <input type="checkbox"  name="remember"/> Remember me
        </label>
          </form>
        </div>
      </div>
    </div>
  );
}
